import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';

import ActionLink from './ActionLink';

const BetaFeatureWarning = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const tutorial_url = props?.tutorial_url ?? false;
	if(!tutorial_url) return null;

	return (
		<div class="gui_help_message">
			<div>
				<p>{i18n("Help")}</p>

				<ActionLink
					_href={tutorial_url}
					_target="_blank"
				>Go to tutorial</ActionLink>
			</div>
		</div>
	)
};

export default injectIntl(BetaFeatureWarning);